import { SteemActionType } from '@popup/steem/actions/action-type.enum';
export const ActiveRpcReducer = (state = { uri: 'NULL', testnet: false }, { type, payload }) => {
    switch (type) {
        case SteemActionType.SET_ACTIVE_RPC:
            return payload;
        default:
            return state;
    }
};
